import { render, staticRenderFns } from "./LmProcessResume.vue?vue&type=template&id=0b6002f5&scoped=true&"
import script from "./LmProcessResume.vue?vue&type=script&lang=js&"
export * from "./LmProcessResume.vue?vue&type=script&lang=js&"
import style0 from "./LmProcessResume.vue?vue&type=style&index=0&id=0b6002f5&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b6002f5",
  null
  
)

export default component.exports